import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MdArrowForward } from 'react-icons/md';
import { useLanguage } from 'hooks/i18n';
import css from './css.module.scss';

const NotFound = () => {
  const [t] = useTranslation('global');
  const [language] = useLanguage();

  return (
    <section className={css.notFound}>
      <span className={css.eyebrow}>404</span>
      <h1 className={css.title}>{t('notFoundPage.title')}</h1>
      <p className={css.text}>{t('notFoundPage.text')}</p>
      <Link to={`/${language}/`} className={css.cta}>
        {t('notFoundPage.cta')}
        <MdArrowForward />
      </Link>
    </section>
  );
};

export default NotFound;
